module.exports = __webpack_public_path__ + "img/video_interativo_bg.c114b8ae.webp";